<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      :items="questions"
      :loading="loading"
      :items-per-page="-1"
      class="elevation-1"
      hide-default-footer
    >
      <template v-slot:item.orden="{ item }">
        <span class="font-weight-bold">#{{ item.orden }}</span>
      </template>

      <template v-slot:item.contenido="{ item }">
        <span class="question-text">{{ truncateText(item.contenido, 80) }}</span>
      </template>

      <template v-slot:item.skill="{ item }">
        <v-chip
          small
          :color="getSkillColor(item.skill)"
          text-color="white"
          class="font-weight-medium"
        >
          {{ item.skill || 'N/A' }}
        </v-chip>
      </template>

      <template v-slot:item.respuestaCorrecta="{ item }">
        <v-chip small color="green" text-color="white">
          {{ getAnswerLetter(item.respuestaCorrecta) }}
        </v-chip>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn
          small
          color="deep-purple lighten-1"
          text
          @click="handleEdit(item)"
          class="cursor-pointer"
        >
          <v-icon small class="mr-1">mdi-pencil-outline</v-icon>
          {{ $t('diagnostics.edit') }}
        </v-btn>
      </template>

      <template v-slot:no-data>
        <div class="text-center pa-4">
          {{ $t('diagnostics.no_questions_found') }}
        </div>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { getAnswerLetterByItem } from '@/constants/diagnostics';

export default {
  name: 'DiagnosticQuestionsTable',
  props: {
    loading: { type: Boolean, default: false },
    questions: { type: Array, default: () => [] },
  },
  computed: {
    headers() {
      return [
        {
          text: '#',
          value: 'orden',
          align: 'center',
          sortable: false,
          width: '8%',
        },
        {
          text: this.$t('diagnostics.question'),
          value: 'contenido',
          align: 'start',
          sortable: false,
          width: '50%',
        },
        {
          text: this.$t('diagnostics.skill'),
          value: 'skill',
          align: 'center',
          sortable: false,
          width: '15%',
        },
        {
          text: this.$t('diagnostics.correct_answer'),
          value: 'respuestaCorrecta',
          align: 'center',
          sortable: false,
          width: '12%',
        },
        {
          text: this.$t('diagnostics.actions'),
          value: 'actions',
          align: 'center',
          sortable: false,
          width: '15%',
        },
      ];
    },
  },
  methods: {
    getAnswerLetter(item) {
      return getAnswerLetterByItem(item);
    },
    truncateText(text, maxLength) {
      if (!text) return '';
      if (text.length <= maxLength) return text;
      return `${text.substring(0, maxLength)}...`;
    },
    getSkillColor(skill) {
      if (!skill) {
        return 'grey';
      }

      const skillPrefix = String(skill).split(' ')[0].toUpperCase();

      if (skillPrefix === 'LOC') {
        return 'teal';
      }

      if (skillPrefix === 'RV') {
        return 'indigo';
      }

      if (skillPrefix === 'IN') {
        return 'deep-orange';
      }

      return 'grey';
    },
    handleEdit(question) {
      this.$emit('edit-question', question);
    },
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.question-text {
  display: block;
  line-height: 1.4;
  max-width: 500px;
}

.v-data-table >>> tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.02);
}
</style>
